export default "__VITE_ASSET__FKjmhXkT__"